import { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 16, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={size} className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"} />
      ))}
    </span>
  );
}

export function StarInput({ value, onChange, size = 32 }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center gap-1.5" data-testid="star-input">
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" data-testid={`star-${i}`}
          onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(0)} onClick={() => onChange(i)}
          className="transition-transform hover:scale-110">
          <Star size={size} className={i <= (hover || value) ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-300"} />
        </button>
      ))}
    </div>
  );
}
